import type { AuctionArtAsset, AuctionCardArtAsset } from '../types';

export function mapApiArtAssetToAuctionCardArtAsset(artAsset: AuctionArtAsset): AuctionCardArtAsset {
  return {
    mainPhoto: artAsset.main_photo ?? null,
    digitalOriginal: artAsset.digital_original,
    artistsNames: artAsset.artists?.map((artist) => artist.name).join(', ') || null,
    name: artAsset.name_english,
    creationYear: artAsset.creation_year ? Number(artAsset.creation_year) : null,
    featured: artAsset.featured,
    type: artAsset.art_asset_type,
  };
}
